module.exports = __webpack_public_path__ + "static/img/son9_active.3beedca9.png";